import '@/styles/globals.css'
import 'maplibre-gl/dist/maplibre-gl.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Plus_Jakarta_Sans, Geist_Mono } from 'next/font/google'
import { SavedHomesProvider } from '@/hooks/use-saved-homes'

const sans = Plus_Jakarta_Sans({
    subsets: ['latin']
})

const mono = Geist_Mono({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1' />
            </Head>

            <SavedHomesProvider>
                <Component {...pageProps} />
            </SavedHomesProvider>
        </div>
    )
}

export default App
